import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

const PieChart = ({ data }) => {
  const svgRef = useRef();
  const wrapperRef = useRef();

  useEffect(() => {
    const svg = d3.select(svgRef.current);
    const { width: containerWidth, height: containerHeight } =
      wrapperRef.current.getBoundingClientRect();

    const width = containerWidth;
    const height = containerHeight;
    const radius = Math.min(width, height) / 2 - 10;

    svg.selectAll("*").remove(); // Limpiar contenido previo

    const color = d3.scaleOrdinal(d3.schemeCategory10);

    const pie = d3.pie().value((d) => d.value);
    const data_ready = pie(data);

    const arc = d3.arc().innerRadius(0).outerRadius(radius);
    const arcLabel = d3.arc().innerRadius(radius * 0.6).outerRadius(radius * 0.6);

    const total = d3.sum(data, (d) => d.value);

    // Contenedor centrado
    const chartGroup = svg
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    // Dibujar sectores con animación
    chartGroup
      .selectAll("path")
      .data(data_ready)
      .join("path")
      .attr("fill", (d, i) => color(i))
      .attr("d", arc)
      .attr("stroke", "white")
      .style("stroke-width", "2px")
      .style("opacity", 0.8)
      .transition()
      .duration(1000)
      .attrTween("d", function (d) {
        const i = d3.interpolate(d.startAngle, d.endAngle);
        return function (t) {
          d.endAngle = i(t);
          return arc(d);
        };
      });

    // Añadir etiquetas
    chartGroup
      .selectAll("text")
      .data(data_ready)
      .join("text")
      .attr("transform", (d) => `translate(${arcLabel.centroid(d)})`)
      .style("text-anchor", "middle")
      .style("font-size", "12px")
      .html(
        (d) =>
          `${d.data.label}\n${d.data.value} (${((d.data.value / total) * 100).toFixed(1)}%)`
      )
      .style("opacity", 0)
      .transition()
      .delay(500)
      .duration(500)
      .style("opacity", 1);
  }, [data]);

  return (
    <div
      ref={wrapperRef}
      style={{ width: "100%", height: "400px" }}
    >
      <svg ref={svgRef}></svg>
    </div>
  );
};

export default PieChart;
